var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"Vlt-tooltip",attrs:{"id":_vm.id}},[_vm._t("default",function(){return [_c('vlt-icon',{staticClass:"Vlt-blue",attrs:{"icon":"help-negative","small":""}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }